import React from "react";
import Header from "@components/Header";
import Footer from "@components/Footer";
import Banner from "@components/Banner";
import Markdown from "@components/Markdown";

import SearchControl from "@components/SearchControl";
import SectionTabs from "@components/Rooms/SectionTabs";
import StayInpired from "@components/Home/StayInspired";
import styles from "./Rooms.module.scss";
import { usePageContext } from "@providers/PageProvider";
import helper from "@utils/helper";
import _ from "lodash";

const View = () => {
  const { pageData, hotel } = usePageContext();
  const banner = helper.formatBanner(pageData);
  const footer = helper.renderDetailsFooter(hotel);
  return (
    <div className="offersPage" data-scroll-container>
      <Header />
      <Banner
        type={"high"}
        titleProps={{ className: styles.title }}
        descProps={{ className: styles.description }}
        contentProps={{ className: styles.content }}
        image={_.get(banner, "image")}
        title={_.get(banner, "title")}
        description={
          <>
            <Markdown content={_.get(banner, "description")} />
          </>
        }
        searchControl={
          <div className="xs:hidden sm:block">
            <SearchControl type="booking" />
          </div>
        }
      />
      <div className="xs:block sm:hidden">
        <SearchControl type="booking" />
      </div>
      {/* <Breadcrumb data={router.breadcrumbs("offers")} mode="dark" /> */}
      <SectionTabs />
      <StayInpired />
      {/* <Tabs defaultActiveKey={"all_offers"} items={TABS} /> */}
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
          phone: footer.phone,
        }}
      />
    </div>
  );
};

export default View;
